import { Box, Button, IconButton } from "@mui/material";
import {
  CSSProperties,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import GenericModal from "../GenericModal";
import MapWrapper from "../MapWrapper";
import CloseIcon from "@mui/icons-material/Close";
import { BrazilianAddress } from "@/types/types";
import { getCoordinatesFromAddress } from "@/hooks/getCoodinatesByAddress";
import { MapCenterHandler } from "../NearbyStoresMap";
import { Marker } from "react-leaflet";
import { PrimaryButton } from "../buttons/PrimaryButton";
import { sharedStyles } from "@/styles/shared";
import PlaceIcon from "@mui/icons-material/Place";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";

interface CoordinateSelectorProps {
  coordinates: [number, number];
  setCoordinates: Dispatch<SetStateAction<[number, number]>>;
  brazilianAddress: BrazilianAddress | null;
}

const CoordinateSelector = (props: CoordinateSelectorProps) => {
  const { brazilianAddress, coordinates, setCoordinates } = props;

  const [openModal, setOpenModal] = useState(false);
  const [mapCenter, setMapCenter] = useState<[number, number]>(coordinates);

  const handleCloseModal = () => setOpenModal(false);

  useEffect(() => {
    if (brazilianAddress) {
      const address = {
        street: brazilianAddress.street,
        district: brazilianAddress.neighborhood,
        city: brazilianAddress.city,
        state: brazilianAddress.state,
        country: "Brazil",
      };

      getCoordinatesFromAddress(address).then((response) => {
        const fetchedCoordinates: [number, number] = [response[0], response[1]];

        setCoordinates(fetchedCoordinates);
        setMapCenter(fetchedCoordinates);
      });
    }
  }, [brazilianAddress]);

  return (
    <Box>
      <GenericModal
        content={
          <Box sx={sharedStyles.verticalContent}>
            <IconButton
              onClick={handleCloseModal}
              sx={{ position: "absolute", right: 0, top: 0 }}
            >
              <CloseIcon />
            </IconButton>

            <MapWrapper mapCenter={mapCenter} styles={mapStyles} zoom={16}>
              <Marker
                position={coordinates}
                draggable
                eventHandlers={{
                  dragend: (event) => {
                    const coordinates = event.target.getLatLng();
                    setCoordinates([coordinates.lat, coordinates.lng]);
                  },
                }}
              />
              <MapCenterHandler />
            </MapWrapper>

            <PrimaryButton
              label={`Confirmar [${coordinates[0].toFixed(5)}, ${coordinates[1].toFixed(5)}]`}
              onClickAction={handleCloseModal}
              styles={sharedStyles.secondaryColor}
              icon={<WhereToVoteIcon />}
            />
          </Box>
        }
        open={openModal}
        onClose={handleCloseModal}
      />

      <Button
        onClick={() => setOpenModal(true)}
        disableElevation
        sx={{
          ...sharedStyles.secondaryColor,
          textTransform: "none",
        }}
        variant="contained"
        startIcon={<PlaceIcon />}
      >
        Definir no mapa
      </Button>
    </Box>
  );
};

export default CoordinateSelector;

const mapStyles: CSSProperties = { height: "50vh", zIndex: 0 };
